/**
 * Application type values corresponding to the application field in location payloads.
 */
export const APPLICATION_AGENT_511 = 'agent_511';
export const APPLICATION_ELS = 'els';
